import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { EventReservation } from './event-reservation.model';
import { DateUtils } from 'ng-jhipster';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
import { AuthServerProvider } from '../../shared/auth/auth-jwt.service';

@Injectable()
export class EventReservationService extends AbstractEntityService {

    protected resourceUrl = 'api/eventreservations';
    private resourceSearchUrl = 'api/_search/eventreservations';
    private resourceSearchNoAuthUrl = 'api/no-auth/_search/eventreservations';
    protected resourceCountUrl = 'api/_search/count/eventreservations';

    constructor(protected http: HttpClient,
                private dateUtils: DateUtils,
                private authServerProvider: AuthServerProvider) {
                    super(http);
                }

    create(eventReservation: EventReservation): Observable<EventReservation> {
        let copy: EventReservation = Object.assign({}, eventReservation);

        return this.http.post<EventReservation>(this.resourceUrl, copy)
                        .map((res: EventReservation) => {
                            return res;
                        });
    }

    createAndPayLater(eventReservation: EventReservation): Observable<EventReservation> {
        let copy: EventReservation = Object.assign({}, eventReservation);

        // the confirmation mail is sent to the student because the payment will be done later
        return this.http.post<EventReservation>(this.resourceUrl + '?params=sendNotifications', copy)
                        .map((res: EventReservation) => {
                            return res;
                        });
    }

    update(event: EventReservation): Observable<EventReservation> {
        let copy: EventReservation = Object.assign({}, event);

        return this.http.put<EventReservation>(this.resourceUrl, copy)
        .map((res: EventReservation) => {
            return res;
        });
    }

    cancel(event: EventReservation): Observable<EventReservation> {
        let copy: EventReservation = Object.assign({}, event);
        return this.http.put<EventReservation>(this.resourceUrl, copy)
                        .map((res: EventReservation) => {
                            return res;
                        });

    }

    find(id: number): Observable<EventReservation> {
        return this.http.get<EventReservation>(`${this.resourceUrl}/${id}`)
                        .map((res: EventReservation) => {
                            return res;
                        });
    }

    query(req?: any): Observable<HttpResponse<EventReservation[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<EventReservation[]>>(this.resourceUrl, options)
            .map((res: HttpResponse<EventReservation[]>) => res)
            ;
    }

    search(req?: any): Observable<HttpResponse<EventReservation[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<EventReservation[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<EventReservation[]>) => res)
            ;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event-reservation/event-reservation.service.ts